import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const PAINS = [
    { key: "landing.pain.1" },
    { key: "landing.pain.2" },
    { key: "landing.pain.3" },
    { key: "landing.pain.4" },
];

export const PainStrip = () => {
    const { t } = useTranslation("common");

    return (
        <section className="border-y border-neutral-200/70 dark:border-neutral-800/70 bg-background-elevated">
            <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
                <motion.h2
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.4 }}
                    className="text-center text-xs font-semibold tracking-[0.2em] uppercase text-neutral-500 dark:text-neutral-400 mb-8"
                >
                    {t("landing.pain.eyebrow")}
                </motion.h2>
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-200 dark:bg-neutral-800 rounded-xl overflow-hidden border border-neutral-200 dark:border-neutral-800">
                    {PAINS.map((p, i) => (
                        <motion.div
                            key={p.key}
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.35, delay: i * 0.07 }}
                            className="bg-white dark:bg-neutral-900 px-5 sm:px-6 py-6 sm:py-8 flex items-start gap-3"
                        >
                            <span className="mt-2 w-1.5 h-1.5 rounded-full bg-accent-primary shrink-0" />
                            <p className="text-sm sm:text-base text-text-primary leading-relaxed">
                                {t(p.key)}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
